import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchAttendingEvents, setAttendingEventStatus } from "./attendingEvents.actions";
import { initialState } from "./attendingEvents.initial-state";
import { AttendingEvent, AttendingEventsResponse, AttendingEventType } from "./attendingEvents.types";

const attendingEventsSlice = createSlice({
  name: "attendingEvents",
  initialState,
  reducers: {
    setAttendingEvents: (state, action: PayloadAction<AttendingEvent[]>) => {
      state.data = action.payload;
    },
    setFirstAttendingEventsPage: (state, action: PayloadAction<AttendingEvent[]>) => {
      state.firstPage = action.payload;
    },
    setCurrentAttendingEventsPage: (state, action: PayloadAction<AttendingEventsResponse>) => {
      state.currentPage = { ...action.payload };
    },
    updateEventStatus: (state, action: PayloadAction<{ eventId: number; status: AttendingEventType }>) => {
      const { eventId, status } = action.payload;
      const updateEventInArray = (events: AttendingEvent[]) => {
        return events.map(event => 
          event.id === eventId ? { ...event, type: status } : event
        );
      };
      state.data = updateEventInArray(state.data);
      state.firstPage = updateEventInArray(state.firstPage);
      state.currentPage.data = updateEventInArray(state.currentPage.data);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAttendingEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAttendingEvents.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchAttendingEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch attending events";
      })
      .addCase(setAttendingEventStatus.fulfilled, (state, action) => {
        const { activityId, status } = action.meta.arg;
        const updateEventInArray = (events: AttendingEvent[]) => {
          return events.map(event => 
            event.id === activityId ? { ...event, type: status } : event
          );
        };
        state.data = updateEventInArray(state.data);
        state.firstPage = updateEventInArray(state.firstPage);
        state.currentPage.data = updateEventInArray(state.currentPage.data);
      });
  },
});

export const { 
  setAttendingEvents, 
  setFirstAttendingEventsPage, 
  setCurrentAttendingEventsPage,
  updateEventStatus 
} = attendingEventsSlice.actions;

export default attendingEventsSlice.reducer;

